import { toast } from "sonner";

import { trpc } from "~/libs/trpc.lib";
import { catalogs$ } from "./catalogs.crud";

/** Triggers a catalog refresh for a datasource and optimistically sets the status to RUNNING. */
export const resyncCatalog = async (datasourceId: string) => {
  try {
    catalogs$[datasourceId].status.set("RUNNING");
    await trpc.catalogs.sync.mutate({ datasourceId });
    toast.success("Catalog sync started");
  } catch (error) {
    toast.error(
      error instanceof Error ? error.message : "Failed to start catalog sync",
    );
  }
};
